'use client'

import MapIcon from "@heroicons/react/24/solid/MapIcon";
import MapPinIcon from "@heroicons/react/24/solid/MapPinIcon";
import LocationCard from "@/components/views/venue-listing/locationCard/LocationCard"
import { useSite } from "@/lib/hooks/site"
import { useTranslation } from "@/hooks/translationContext";
import {Link} from "@/components/CustomLink";

interface District {
  close_district: {
    id: string
    title: string
    slug: string
  }
}

interface Service {
  descriptions: Array<{
    title: string
    slug: string
  }>
}

interface Props {
  title: string
  service?: Service
  districts: District[]
}

export default function CloseDistrictsList({ title, service, districts }: Props) {
  const site = useSite()
  const {t} = useTranslation()

  const getHrefLink = (district: string) => {
    if (district && !service) {
      return `/${district}-${site.setting?.routes?.districtSpecificList}`
    }

    if (!district && service) {
      return `/${service.descriptions?.[0]?.slug}`
    }

    if (service && district) {
      return `/${district}-${service.descriptions?.[0]?.slug}`
    }

    return site.setting?.routes?.generalList
  }

  const getTextWithoutSpace = () => {
    return t("nearby-districts-section-title", {
      service: service?.descriptions?.[0]?.title || "",
      district: title || "",
      defaultValue: `${title?.trim()} Yakınındaki Semtler`
    })
  }

  return (
    <section className="mt-10 flex flex-col gap-2">
      <h2 className="text-sm flex items-center py-2 gap-2 font-bold">
        <MapIcon className="size-6" aria-hidden="true" />
        {getTextWithoutSpace()}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 py-6">
        {districts.map((district) => {
          const districtTitle = district.close_district?.title
          const serviceTitle = service?.descriptions?.[0]?.title
          const fullTitle = `${districtTitle} ${serviceTitle || ''}`.trim()

          return (
            <Link
              href={getHrefLink(district.close_district?.slug)}
              key={district.close_district?.id}
              className="max-md:w-full"
              title={fullTitle}
            >
              <LocationCard
                icon={<MapPinIcon className="size-4" aria-hidden="true" />}
                title={fullTitle}
              />
            </Link>
          )
        })}
      </div>
    </section>
  )
}
